
import { handleActions } from 'redux-actions';

import { TASK_ACTION_TYPES } from './constants';
import TasksState from './TasksState';
import { PROJECT_ACTION_TYPES } from '../projects/constants';

import type { Action } from '../types';
import type {
  ReceiveTaskPayload,
  ReceiveTasksPayload,
  ReceiveSubTaskPayload,
  ReceiveSubTasksPayload
} from './types';

const initialState = new TasksState();

const actions = {
  [TASK_ACTION_TYPES.CREATE_TASK]: createTask,
  [TASK_ACTION_TYPES.FETCH_TASKS]: fetchTasks,
  [TASK_ACTION_TYPES.RECEIVE_TASK]: receiveTask,
  [TASK_ACTION_TYPES.RECEIVE_TASKS]: receiveTasks,
  [TASK_ACTION_TYPES.RECEIVE_TOGGLED_TASK_COMPLETENESS]: receiveToggledTaskCompleteness,
  [TASK_ACTION_TYPES.FETCH_SUBTASKS]: fetchSubTasks,
  [TASK_ACTION_TYPES.RECEIVE_SUBTASKS]: receiveSubTasks,
  [TASK_ACTION_TYPES.CREATE_SUBTASK]: createSubTask,
  [TASK_ACTION_TYPES.RECEIVE_SUBTASK]: receiveSubTask,
  [TASK_ACTION_TYPES.RECEIVE_TOGGLED_SUBTASK_COMPLETENESS]: receiveToggledSubTaskCompleteness,
  [TASK_ACTION_TYPES.RECEIVE_DELETED_SUBTASK]: receiveDeletedSubTask,

  // Project actions
  [PROJECT_ACTION_TYPES.RECEIVE_ACTIVE_PROJECT]: clearTasks
};

function clearTasks(state: TasksState): TasksState {
  return state.setTasks(null);
}

function fetchTasks(state: TasksState): TasksState {
  return state.setIsFetchingTasks(true);
}

// eslint-disable-next-line object-curly-spacing
function receiveTasks(state: TasksState, { payload }: Action<ReceiveTasksPayload>): TasksState {
  if (!payload) {
    return state;
  }
  return state
    .setIsFetchingTasks(false)
    .setTasks(payload.tasks);
}

function createTask(state: TasksState): TasksState {
  return state.setIsCreatingTask(true);
}

// eslint-disable-next-line object-curly-spacing
function receiveTask(state: TasksState, { payload }: Action<ReceiveTaskPayload>): TasksState {
  if (!payload) {
    return state;
  }
  return state
    .setIsCreatingTask(false)
    .addOrReplaceTask(payload.task);
}

// eslint-disable-next-line object-curly-spacing
function receiveToggledTaskCompleteness(state: TasksState, { payload }: Action<ReceiveTaskPayload>): TasksState {
  if (!payload) {
    return state;
  }
  return state.addOrReplaceTask(payload.task);
}

function fetchSubTasks(state: TasksState): TasksState {
  return state.setIsFetchingSubTasks(true);
}

// eslint-disable-next-line object-curly-spacing
function receiveSubTasks(state: TasksState, { payload }: Action<ReceiveSubTasksPayload>): TasksState {
  if (!payload) {
    return state;
  }
  return state
    .addOrReplaceSubTasks(payload.subTasks)
    .setIsFetchingSubTasks(false);
}

function createSubTask(state: TasksState): TasksState {
    return state.setIsCreatingSubTask(true);
}

// eslint-disable-next-line object-curly-spacing
function receiveSubTask(state: TasksState, { payload }: Action<ReceiveSubTaskPayload>): TasksState {
  if (!payload) {
    return state;
  }
  return state
    .addOrReplaceSubTask(payload.subTask)
    .setIsCreatingSubTask(false);
}

function receiveToggledSubTaskCompleteness(state: TasksState, { payload }: Action<ReceiveSubTaskPayload>): TasksState {
  if (!payload) {
    return state;
  }
  return state.addOrReplaceSubTask(payload.subTask);
}

function receiveDeletedSubTask(state: TasksState, { payload }: Action<ReceiveSubTaskPayload>): TasksState {
  if (!payload) {
    return state;
  }
  return state.removeSubTask(payload.subTask);
}

export default handleActions(actions, initialState);



// WEBPACK FOOTER //
// ./src/redux/tasks/reducer.js